import type { ModerationProfileBase } from '../types/moderationProfile';

export const getProfileFieldValue = (profile: ModerationProfileBase, key: string): string => {
  const direct = (profile as unknown as Record<string, unknown>)[key];
  if (direct !== undefined && direct !== null && direct !== '') {
    return String(direct);
  }
  const fromMeta = profile.metadata?.[key];
  if (fromMeta !== undefined && fromMeta !== null && fromMeta !== '') {
    return String(fromMeta);
  }
  return '';
};

export const getProfileListLabel = (profile: ModerationProfileBase): string => {
  const name = getProfileFieldValue(profile, 'name');
  if (name) return name;
  if (profile.profile_user_id) return profile.profile_user_id;
  return `Profile ${profile.id.slice(0, 8)}`;
};

export const formatProfileFieldDisplay = (value: string): string => (value.trim() ? value : '—');
